import { Pipe, PipeTransform } from '@angular/core'
import { CommonService } from '@lla-platform/core/core-util'

@Pipe({
  name: 'llaStripHtml',
  standalone: false
})
export class StripHtmlPipe implements PipeTransform {
  constructor(private commonService: CommonService) {}
  transform(value?: string): string {
    return this.commonService.htmlToPlainText(value ?? '')
  }
}
